import ProductRoutes from "./product";
import GridReportRoutes from "./grid-reports";

export default [
    ...ProductRoutes,
    ...GridReportRoutes
];
